import { MainButton, MilestoneContainer, SmallButton } from "../../Styles";
import { CONTRACT_NAME, currentUsername, currentWebsiteURL } from "../config";
import {
  Table,
  TableData,
  TableHeader,
  TableRow,
} from "../css/ListingPageStyles";
import { deleteListing, get_ingredient_count } from "./listings";
import { getAssetSymbol, getPrecisionFromAsset, getWalletSession } from "./wallet_functions";

const maxNameLength = 13;
function uint64ToName(val)
{
    const charmap = ".12345abcdefghijklmnopqrstuvwxyz";
    let lastIndex = maxNameLength - 1;
    let result = new Array(maxNameLength);
    for (let i = 0; i < maxNameLength; ++i) result[i] = '.';
    let tmp = BigInt(val) + 0n;
    for (let i = 0; i < maxNameLength; ++i)
    {
        let c = charmap[tmp & BigInt(i == 0 ? 0x0f : 0x1f)];
        result[lastIndex-i] = c;
        tmp >>= BigInt(i == 0 ? 4 : 5);
    }
    while(lastIndex > 0 && result[lastIndex] === '.') lastIndex--;
    return result.slice(0, lastIndex + 1).join('');
}

function split128To64(input) {
    const value = BigInt(input);
    const mask64 = BigInt("0xFFFFFFFFFFFFFFFF"); // 64 bit mask
    const shift64 = BigInt(64);
    
    // shifting right 64 bits will give you the first name
    const firstNameValue = value >> shift64;

    // masking with 0xFFFFFFFFFFFFFFFF will give you the second name
    const secondNameValue = value & mask64;

    return [firstNameValue.toString(), secondNameValue.toString()];
}







export const showListings = (
  listings,
  setEnterModalText,
  setLoadingDisplay,
  setEnterButtonsDisplay,
  setEnterModalDisplay,
  setRefresh
) => {
  return (
    <span>
      <span className={listings?.length > 0 && "hidden"}>
        <MilestoneContainer>
          You haven't created any listings
        </MilestoneContainer>
      </span>

    <span className={listings?.length == 0 && "hidden"}>
        <br/>
      <Table>
        <thead>
          <TableRow>
            <TableHeader>Actions</TableHeader>
            <TableHeader>ID</TableHeader>
            <TableHeader>Ingredients</TableHeader>
          </TableRow>
        </thead>
        <tbody>
          {listings
            ?.sort((a, b) => b.time_created - a.time_created)
            .map((listing, index) => (
              <TableRow key={index}>
                <TableData>
                  <a
                    href={`${currentWebsiteURL}/listing/${listing.listing_id}`}
                  >
                    <SmallButton>View</SmallButton>
                  </a>
                  &nbsp;&nbsp;
                  <SmallButton
                    onClick={() => {
                      deleteListing(
                        listing.listing_id,
                        setEnterModalText,
                        setLoadingDisplay,
                        setEnterButtonsDisplay,
                        setEnterModalDisplay,
                        setRefresh
                      );
                    }}
                  >
                    Delete
                  </SmallButton>
                </TableData>
                <TableData>{listing.listing_id}</TableData>
                <TableData>{get_ingredient_count(listing)}</TableData>
              </TableRow>
            ))}
        </tbody>
      </Table>
      </span>
    </span>
  );
};

export const showBalances = (
    userData,
    balances,
    tokenAction, setTokenAction,
    showWithdrawModal,
    setShowWithdrawModal,
    selectedToken, setSelectedToken, selectedPrecision, setSelectedPrecision, selectedContract, setSelectedContract,
    setEnterModalText,
    setLoadingDisplay,
    setEnterButtonsDisplay,
    setEnterModalDisplay,
  ) => {
    return (
      <span>
  
 
          <br/>
          <Table>
            <thead>
              <TableRow>
                <TableHeader>Actions</TableHeader>
                <TableHeader>Balance</TableHeader>
                <TableHeader>Contract</TableHeader>
              </TableRow>
            </thead>
            <tbody>
                <TableRow>
                  <TableData>
                    <SmallButton
                        onClick={() => {
                            setTokenAction("Deposit");
                            setSelectedContract("eosio.token");
                            setSelectedPrecision(8);
                            setSelectedToken("WAX");
                            setShowWithdrawModal(true);
                        }}                    
                    >Deposit</SmallButton>
                    &nbsp;&nbsp;
                    <SmallButton
                        onClick={() => {
                            setTokenAction("Withdraw");
                            setSelectedContract("eosio.token");
                            setSelectedPrecision(8);
                            setSelectedToken("WAX");
                            setShowWithdrawModal(true);
                        }}
                    >Withdraw</SmallButton>
                  </TableData>
                  <TableData>{userData?.wax_balance ? userData.wax_balance : "0 WAX"}</TableData>
                  <TableData>eosio.token</TableData>
                </TableRow>
                {balances?.length > 0 && balances.map((token, index) => (
                <TableRow key={index}>
                  <TableData>

                    <SmallButton
                        onClick={() => {
                            setTokenAction("Withdraw");
                            setSelectedContract(uint64ToName(split128To64(token.tokencombo)[1]));
                            setSelectedPrecision(getPrecisionFromAsset(token.balance));
                            setSelectedToken(getAssetSymbol(token.balance));
                            setShowWithdrawModal(true);                            
                        }}
                    >Withdraw</SmallButton>                    
                  </TableData>
                  <TableData>{token.balance}</TableData>
                  <TableData>{uint64ToName(split128To64(token.tokencombo)[1])}</TableData>

                </TableRow>
              ))}                

            </tbody>
          </Table>
        </span>

    );
  };


  
  export const submitTokenTransaction = async (tokenAction, token_name, precision, amount, contract, setEnterModalText, setLoadingDisplay, setEnterButtonsDisplay, setEnterModalDisplay) => {
    setEnterModalDisplay('');
    setEnterModalText('Awaiting confirmation...');
    let walletSession = await getWalletSession(setEnterModalText);
    let session = walletSession[0];
    let this_user = walletSession[1];
    let this_permission = walletSession[2];

    let action;

    if(tokenAction == "Deposit"){
        action = [{
            account: CONTRACT_NAME,
            name: "announcedepo",
            authorization: [
                {
                  actor: this_user,
                  permission: this_permission,
                },
              ],
              data: {
                user: this_user, 
                listing_fee: {"token_symbol": "8,WAX", "contract": "eosio.token"},
              },
            },

            {
              account: "eosio.token",
              name: "transfer",
              authorization: [
                {
                  actor: this_user,
                  permission: this_permission,
                },
              ],
              data: {
                from: this_user, 
                to: CONTRACT_NAME,
                quantity: Number(amount).toFixed(8) + " WAX",
                memo: "|add_balance|"
              },
            }]
    }
    else if(tokenAction == "Withdraw"){
        action = [            {
            account: CONTRACT_NAME,
            name: "withdraw",
            authorization: [
              {
                actor: this_user,
                permission: this_permission,
              },
            ],
            data: {
              wallet: this_user, 
              contract: contract,
              amount: Number(amount).toFixed(Number(precision)) + " " + token_name,
            },
          }]
    }
    else{
        setEnterModalText("Invalid action");
        return;
    }



    try {   

      
    

      const response = await session[0].signTransaction({
        actions: action
      }, {
  
        blocksBehind: 3,
        expireSeconds: 1200,
        broadcast: true,
      })
      setLoadingDisplay('');
      setEnterButtonsDisplay('hidden');
      setEnterModalText('Processing your transaction...')
      const timer = setTimeout(() => {
        
          setEnterModalText('Your transaction was submitted');
          setLoadingDisplay('none');
          setEnterButtonsDisplay('');
    
      }, 1000);
      return () => clearTimeout(timer);
  
    } catch(e) {
      setEnterModalText(JSON.stringify(e.message));
      console.log(e)
      
    }
 
  }